module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "brand"
    }
  }, [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.imgUrl,
      "title": "商标",
      "alt": "商标img"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "detail"
    }
  }, [_c('p', {
    attrs: {
      "id": "tmName"
    }
  }, [_vm._v(_vm._s(_vm.tmName) + "\n      "), _c('span', {
    attrs: {
      "id": "currentStatus"
    }
  }, [_vm._v(_vm._s(_vm.currentStatus))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info"
    }
  }, [_c('span', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("申请日期：")]), _vm._v(_vm._s(_vm.appDate))]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("类别：")]), _vm._v(_vm._s(_vm.intCls))]), _vm._v(" "), _c('span', {
    staticClass: "block",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("申请人：")]), _vm._v(_vm._s(_vm.applicantCn))]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("注册号：")]), _vm._v(_vm._s(_vm.regNo))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da808a62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brand.vue
// module id = 1064
// module chunks = 40